// extracted by mini-css-extract-plugin
var _1 = "TagBar-moduleTagBar__a7w7V";
var _2 = "TagBar-modulehidden__BRbds";
var _3 = "TagBar-moduleshowButton__e8iPd";
var _4 = "TagBar-moduletag__Xo2uF Tag-moduleTag__FLr9H";
var _5 = "TagBar-moduletagWrapper__eAIZk";
export { _1 as "TagBar", _2 as "hidden", _3 as "showButton", _4 as "tag", _5 as "tagWrapper" }
